import { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import SplashScreen from "./SplashScreen";

/**
 * ChannelLanding
 *
 * What a marketing scan (flyer, standie, lift banner, door tag, apartment QR)
 * or a referral link lands on. It does NOT ask anyone to log in — the visitor
 * gets the normal splash -> welcome -> home flow and can browse first, exactly
 * as if they'd typed the site root. Login happens later, at checkout.
 *
 * Its only job is attribution:
 *   1. counts the scan  (AcquisitionVisit, one row per page load)
 *   2. remembers the channel in localStorage, so whenever the visitor finally
 *      registers — through the modal on Home or the full-page OTP screen — the
 *      signup is credited to this channel instead of "organic".
 * Both Validate.jsx and ValidateModal.jsx read that key at OTP verification and
 * clear it once the customer is created.
 */

// Exact paths, not substring matches: with the catch-all /:referralCode route a
// referral code like "stallion" would otherwise be read as the "stall" channel.
const CHANNEL_BY_PATH = {
  "/flyer": "flyer",
  "/standie": "standie",
  "/stall": "stall",
  "/sample": "sample",
  "/lift-banner": "lift_banner",
  "/door-tag": "door_tag",
  "/alpine": "alpine",
  "/apt/alpine": "alpine",
  "/apt/hiranandani": "hiranandani",
};

export default function ChannelLanding() {
  const location = useLocation();
  const { referralCode } = useParams();

  // Guards against React.StrictMode's dev-only double-invoke of effects, which
  // would otherwise record two visits per real page load.
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) return;
    hasTracked.current = true;

    const path = location.pathname.replace(/\/+$/, "").toLowerCase();
    const channel = CHANNEL_BY_PATH[path];

    if (channel) {
      localStorage.setItem("acquisitionChannel", channel);
      axios
        .post(
          "/User/track-visit",
          { channel },
          { baseURL: "https://dailydish.in/api" },
        )
        .catch((err) => console.log("track-visit failed", err.message));
    } else if (referralCode) {
      // Not a marketing route — the catch-all matched, so treat it as a referral
      // link. The backend credits these as "refer" at registration.
      localStorage.setItem("referralCode", referralCode);
    }
  }, [location.pathname, referralCode]);

  return <SplashScreen />;
}
